<template>
  <div class="">
    <template v-if="isPageAllowed">
         <div style="transition: none;" >
            <div class="tab-bar relative">
                <el-tabs v-model="activeTabName" @tab-click="changeTab">
                    <el-tab-pane label="PC端系统" name="PcLog" v-if="pageActionNames.indexOf('system_log_page') > -1"></el-tab-pane>
                    <el-tab-pane label="小程序" name="WeappLog" v-if="pageActionNames.indexOf('mp_system_log_page') > -1"></el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div class="pl10 pr10 pb20 bg-white">
            <component
                :is="activeTabName"
                :pageFieldsNames="pageFieldsNames"
            />
        </div>
    </template>
     <template v-else>
        <NoPermissionInfo>
            <p>此页面为系统所有操作的操作日志查看页面。</p>
        </NoPermissionInfo>
    </template>
  </div>
</template>

<script>
import {pageMixin} from '../../mixins/pageMixin';
import PcLog from './page/pc.vue';
import WeappLog from './page/weapp.vue';
export default {
    name: 'SystemLog',
    mixins: [pageMixin],
    components: {
        PcLog,
        WeappLog,
    },
    data() {
        return {
            activeTabName: this.$route.query.topage || 'PcLog',
        }
    },
    computed: {
        pageFieldsNames() {
            const data = {
                PcLog: 'system_log_page',
                WeappLog: 'mp_system_log_page'
            };
            const pageAction = this.pageAction.find(item=> {
                return item.name === data[this.activeTabName]
            });
            const fields = pageAction?.fields || [];
            console.log(pageAction, '---');
            return (fields[0]?.children || []).map(item=> item.name)
        },
        // 
    },
    methods: {
        changeTab(tab){
            let active_name = tab.name ? tab.name : ''
            this.$router.push({
                name:'system_log',
                query: {
                    topage: active_name
                },
            });
        },
    }
}
</script>

<style lang="scss" scoped>

.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
    background-color: #fff;
    margin-bottom: 10px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
    .el-tabs__active-bar {
        min-width: 56px;
    }
}
.tab-bar ::v-deep .el-tab-pane{
    margin: 0 15px;
}
</style>